import React from 'react';

import { BUTTON_BACKGROUND_APPEARANCES, TextButton } from 'lib/button';
import { focusOutlinesStyles } from 'lib/core';
import { IconHelp } from 'lib/icons';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { getRem } from './../../core';
import { footerButtonStyles } from '../shared-styles';

const StyledHelpButton = styled(TextButton)`
  ${footerButtonStyles};
  box-sizing: border-box;
  max-width: ${getRem(196)};
  position: absolute;
  text-align: left;
  top: ${({ theme }) => theme.size.spacing.medium.value};

  &&& {
    :focus-visible {
      ${focusOutlinesStyles.dark};
    }
  }

  && {
    &:hover,
    &:focus-visible {
      &::after {
        background-color: ${({ theme }) => theme.color.state.light.hover.value};
      }
    }
  }
`;

const HelpButton = ({ icon = <IconHelp />, isCollapsed = false, label, onClick = undefined, ...other }) => (
  <StyledHelpButton
    backgroundAppearance={BUTTON_BACKGROUND_APPEARANCES.DARK}
    hideText={isCollapsed || !label}
    icon={icon}
    onClick={onClick}
    text={label}
    {...other}
  />
);

HelpButton.propTypes = {
  /** Outputs icon inside the help button. Use icon component from the library */
  icon: PropTypes.node,
  /** If true, component is collapsed */
  isCollapsed: PropTypes.bool,
  /** Help button label */
  label: PropTypes.node.isRequired,
  /** Callback that is called on click */
  onClick: PropTypes.func,
};

export { HelpButton };
